import { createCRUDEndpoints } from '@/api/factory/crud';
import { BannerStandImageJSON } from '@/store/modules/banner-stand-images/banner-stand-image';
import { PublishStatus } from '@/store/types';
import httpClient from '@/api/http-client';
import { RequestConfig } from '../types';

export type ListParams = {
  search?: string;
  status?: PublishStatus;
  product_id?: number;
  page?: string | number;
  sort?: string;
  direction?: 'asc' | 'desc';
};

export const {
  list,
  get,
  store,
  remove,
  restore,
} = createCRUDEndpoints<BannerStandImageJSON, ListParams>({
  slug: {
    base: 'banner-stand-images',
    list: 'banner-stand-images',
    get: 'banner-stand-image',
    store: 'banner-stand-image',
    remove: 'banner-stand-image'
  }
});

export function getUsedProducts(params?: { language_code?: string; include_ordered?: boolean }, config?: RequestConfig) {
  return httpClient.get<number[] | { products: number[]; ordered: number[] }>('banner-stand-images/used-products', { ...config, params });
}

export function getExistingLanguages(productId: number, config?: RequestConfig) {
  return httpClient.get<string[]>(`banner-stand-images/existing-languages/${productId}`, config);
}

export interface BannerStandOrderItem {
  product_id: number;
  banner_stand_image_id: number;
}

export interface BannerStandOrderRequest {
  location_id: number;
  items: BannerStandOrderItem[];
  notes?: string;
}

export function submitOrder(data: BannerStandOrderRequest, config?: RequestConfig) {
  return httpClient.post('banner-stand-order', data, config);
}

export type OrderListParams = {
  practice_id?: number;
  status?: string;
  page?: string | number;
  sort?: string;
  direction?: 'asc' | 'desc';
};

export function listOrders(params?: OrderListParams, config?: RequestConfig) {
  return httpClient.get('banner-stand-orders', { ...config, params });
}

export function getOrder(id: number, config?: RequestConfig) {
  return httpClient.get(`banner-stand-order/${id}`, config);
}

